import { AbstractStruct } from '@pushly/models/lib/structs/abstract-struct'
import { Expose } from 'class-transformer'
import { IsIn, IsInt, Min } from 'class-validator'
import { TransformToLowercase } from '@pushly/models/lib/class-transformers/transform-to-lowercase'

type NotificationTtlMetric = 'days' | 'hours' | 'minutes'

export class JourneyNotificationTtlConfig extends AbstractStruct {
    @Expose()
    @Min(0)
    @IsInt()
    public ttlSeconds: number

    @Expose()
    @TransformToLowercase({ toClassOnly: true })
    @IsIn(['days', 'hours', 'minutes'])
    public ttlMetric: NotificationTtlMetric
}
